import { render, staticRenderFns } from "./idleFlipBook.vue?vue&type=template&id=13370a27&scoped=true&"
import script from "./idleFlipBook.vue?vue&type=script&lang=js&"
export * from "./idleFlipBook.vue?vue&type=script&lang=js&"
import style0 from "./idleFlipBook.vue?vue&type=style&index=0&id=13370a27&lang=scss&scoped=true&"
import style1 from "./idleFlipBook.vue?vue&type=style&index=1&id=13370a27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13370a27",
  null
  
)

export default component.exports